module.exports = __webpack_public_path__ + "img/RIO.1a0a4c28.png";